import { isNullish } from "@tinyurldev/tu-ui-vue";

export default function (query) {
  return (
    !isNullish(query) &&
    !isNullish(query.subscription) &&
    !isNullish(query.interval)
  );
}
